import { Routes, Route, Outlet } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { AuthGuard } from './auth/AuthGuard';
import { OrgGuard } from './auth/OrgGuard';
import { OrgProvider } from './context/OrgContext';
import { HomePage } from './pages/HomePage';
import { FeedPage } from './components/Feed/FeedPage';
import { StoryPage } from './components/Story/StoryPage';
import { MaterialPage } from './components/Material/MaterialPage';
import { MaterialsPage } from './components/Materials/MaterialsPage';
import { WrappedPage } from './components/Wrapped/WrappedPage';
import { StreamsPage } from './components/Streams/StreamsPage';
import { StreamPage } from './components/Streams/StreamPage';
import { TuplesPage } from './components/Tuples/TuplesPage';
import { SitemapsPage } from './components/Sitemaps/SitemapsPage';
import { RundownsPage } from './components/Rundown/RundownsPage';
import { RundownPage } from './components/Rundown/RundownPage';

export default function App() {
  return (
    <AuthGuard>
      <OrgProvider>
        <Routes>
          {/* Org selection routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />

          {/* Org-scoped routes */}
          <Route path="/:orgSlug" element={<OrgGuard />}>
            <Route element={<Layout><Outlet /></Layout>}>
              <Route index element={<FeedPage />} />
              <Route path="feed" element={<FeedPage />} />
              <Route path="streams" element={<StreamsPage />} />
              <Route path="stream/:id" element={<StreamPage />} />
              <Route path="story/:id" element={<StoryPage />} />
              <Route path="material/:id" element={<MaterialPage />} />
              <Route path="materials" element={<MaterialsPage />} />
              <Route path="tuples" element={<TuplesPage />} />
              <Route path="sitemaps" element={<SitemapsPage />} />
              <Route path="wrapped" element={<WrappedPage />} />
              <Route path="rundowns" element={<RundownsPage />} />
              <Route path="rundown/:id" element={<RundownPage />} />
            </Route>
          </Route>
        </Routes>
      </OrgProvider>
    </AuthGuard>
  );
}
